<template>
  <div
    :ref="'popup'"
    v-click-outside="() => $emit('close')"
    class="modal-wrapper"
    tabindex="-1"
    @keydown="keyPressed"
  >
    <div class="main-column">
      <div
        v-if="loggedUserEntry"
        class="edit-button button-icon"
        @click="$emit('edit', person, entry, rowTimezone)"
      >
        <img :src="require('@/assets/_desktop/_calendars/edit.svg')">
      </div>
      <div
        class="close-button button-icon"
        @click="$emit('close')"
      >
        <img :src="require('@/assets/_desktop/_calendars/Close.svg')">
      </div>

      <div>
        <div class="header">
          <img
            :src="getAvatar(person)"
            :style="{ background: getAvatar(person).slice(-4) === '.svg' ? (person.color ? person.color : '#D1D4F0') : 'unset' }"
            class="avatar"
          >
          <div>
            {{ person.name }}
          </div>
        </div>
        <div
          v-if="isFollowed && $store.state.teams.length > 1"
          class="row"
        >
          <team-icon
            :team="entryTeam"
            class="image-element"
          />
          <div>
            {{ entryTeam.name }}
          </div>
        </div>

        <div v-if="!holidayType">
          <div class="row">
            <div class="image-element">
              <div
                class="color-circle"
                :style="{ backgroundColor: colorHex }"
              />
            </div>
            <div>
              {{ entry.location.name }}
            </div>
          </div>
          <div class="row">
            <img
              :src="require('@/assets/_desktop/_calendars/Clock.svg')"
              class="image-element"
            >
            <div>
              <div class="time-section">
                <div>
                  {{ startDateFormatted }}
                </div>
                <img :src="require('@/assets/_desktop/_calendars/arrow-from-to.svg')">
                <div>
                  {{ endDateFormatted }}
                </div>
              </div>
              <div class="time-diff">
                {{ timeDiff }}
              </div>
            <!-- <div>
              {{
                moment(startDate).calendar(null, texts().momentDayNames) +
                  ', ' +
                  startDate.format('MMMM D')
              }}
            </div> -->
            </div>
          </div>
          <div
            v-if="timezone"
            class="row"
          >
            <img
              :src="require('@/assets/_desktop/_calendars/Time-zone.svg')"
              class="image-element"
            >
            <div class="entry-location">
              {{ timezoneName }}
            </div>
          </div>
          <div
            v-if="entry.comment"
            class="row"
          >
            <img
              :src="require('@/assets/_desktop/_calendars/Comment.svg')"
              class="image-element"
            >
            <div class="comment-content">
              {{ entry.comment }}
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div class="image-element">
              <img :src="holidayType.image">
            </div>
            <div>
              {{ holidayType.name }}
              <span v-if="holidayType.value != 'sick'">
                time off</span>
            </div>
          </div>
          <div class="row">
            <div class="image-element">
              <img :src="require('@/assets/_desktop/_calendars/Calendar.svg')">
            </div>
            <div>
              <div class="time-section">{{ holidayRange }}</div>
              <div class="time-diff">
                {{ $tc('dayPlural', daysDuration) }}
              </div>
            </div>
          </div>
          <div
            v-if="timezone"
            class="row"
          >
            <img
              :src="require('@/assets/_desktop/_calendars/Time-zone.svg')"
              class="image-element"
            >
            <div class="entry-location">
              {{ timezoneName }}
            </div>
          </div>
          <div
            v-if="entry.comment"
            class="row"
          >
            <img
              :src="require('@/assets/_desktop/_calendars/Comment.svg')"
              class="image-element"
            >
            <div class="comment-content">
              {{ entry.comment }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import vClickOutside from 'v-click-outside'
import Color from '@/components/Color'
import Constants from '@/components/Constants'
import User from '@/components/User'
import TeamIcon from '@/components/Team/TeamIcon'

export default {
  name: 'CalendarEntryPopup',
  components:{
    TeamIcon
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  mixins: [Color, Constants, User],
  props: {
    person: Object,
    rowTimezone: String,
    entry: Object,
    isFollowed: {
      type: Boolean,
      default: false,
    },
    clock12: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      startDate: '',
      endDate: '',
      timeDiff: '',
      holidayType: {},
      timezone: undefined,
    }
  },
  computed:{
    loggedUserEntry() {
      return this.person.userId === this.userId
    },
    startDateFormatted() {
      return this.startDate.tz(this.rowTimezone).format(this.clock12 ? 'h:mm A' : 'HH:mm')
    },
    endDateFormatted() {
      return this.endDate.tz(this.rowTimezone).format(this.clock12 ? 'h:mm A' : 'HH:mm')
    },
    entryTeam() {
      return this.$store.state.teams.find(x=>x.teamId === this.entry.teamId)
    },
    daysDuration() {
      return Math.round(moment(this.endDate).diff(this.startDate, 'hours') / 24)
    },
    holidayRange() {
      let startDate = moment(this.startDate).tz(this.timezone)
      let endDate = moment(this.endDate).tz(this.timezone)
      if (startDate.format('DD MMM YY') === endDate.clone().subtract(1,'days').format('DD MMM YY'))
        return startDate.formatLocalized('ddd, MMM D')
      else {
        let startString = startDate.formatLocalized('ddd, MMM D')
        // startString = this.$t('weekDaysShort')[startDate.weekday()]+', ' + startString
        let endString = endDate.subtract(1, 'days').formatLocalized('ddd, MMM D')
        // endString = this.$t('weekDaysShort')[endDate.weekday()]+', ' + endString
        return startString + ' - ' + endString
      }
    },
    timezoneName() {
      let tzObj = this.$store.state.timezonesGlobal.find(x=>x.value === this.timezone)
      if (tzObj)
        return  tzObj.name
      else {
        let tzSplit = this.timezone.split('/')
        let tempTzArray = this.$store.state.timezonesGlobal.filter(x=>x.value.split('/')[0] === tzSplit[0])
        let tzObj = tempTzArray.find(x=>x.city === tzSplit[1])

        return tzObj.name
      }
    },
  },
  created() {
    this.startDate = moment(this.entry.start)
    this.endDate = moment(this.entry.end)

    this.holidayType = this.daysOffTypes().find(x=>x.value === this.entry.type)
    if (!this.holidayType) {
      this.timeDiff = this.longerDurationFormat(this.entry.start,this.entry.end)
      this.colorHex = this.entry.location.color
    } else {
      this.colorHex = this.holidayType.color
    }
    if (this.entry.timezone){
      this.timezone = this.entry.timezone
    }
    else if (this.entry.location && this.entry.location.timezone){
      this.timezone = this.entry.location.timezone
    }

  },
  mounted() {
    this.$emit('popupMounted')
  },
  methods: {
    keyPressed(e) {
      if (e.key === 'Escape') {
        this.$emit('close')
      }
    },
  },
}
</script>

<style scoped lang="scss">
.color-circle {
  width: 14px;
  height: 14px;
  border-radius: 20px;
  margin: 6px 5px 5px;
  cursor: pointer;
  .color-input & {
    margin-left: 0;
  }
}

.button-icon {
  width: 36px;
  height: 36px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 14px;

  &:hover {
    background-color: $white-lilac;
  }
  &:focus {
    background-color: $white-lilac;
    outline: none;
  }
  &.edit-button {
    right: 50px;
  }
  &.close-button {
    right: 14px;
  }
}

.modal-wrapper {
  box-sizing: border-box;
  z-index: 12;
  border: 1px solid $flax-bloom; 
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(black, 0.15);
  width: 338px;
  position: absolute;
  outline: none;
  @include respond-below(sm) {
    border-bottom: 0;
    border-left: 0;
    border-right: 0;
    box-shadow: 0 -4px 8px 0 rgba(black, 0.15);;
  }


  .main-column {
    font-size: 14px;
    position: relative;
    padding: 24px;
    line-height: 20px;
    .header {
      color: $black;
      display: flex;
      font-size: 16px;
      letter-spacing: 0.3px;
      line-height: 18px;
      margin-bottom: 24px;
      margin-right: 62px;
      align-items: center;
      div {
        @include font-rule('averta-bold');
        overflow-wrap: anywhere;
      }
      .avatar {
        margin-right: 17px;
      }
    }
    .row {
      display: flex;
      margin-bottom: 24px;
      position: relative;
      align-items: center;
      .right{
        position: absolute;
        color: $bluebell;
        right: 0;
      }
      &:last-child {
        margin-bottom:12px;
      }
      div:nth-child(2) {
        padding-top: 2px;
      }
      .time-section {
        display: flex;
        margin-bottom: 12px;
        div {
          margin-right: 12px;
          &:last-child {
            margin-right: 0px;
          }
        }
        img {
          margin-right: 12px;
        }
      }
      .time-diff {
          // position: absolute;
          // right: 0px;
          line-height: 16px;
          color: $bluebell;
        }
      .entry-location {
        color: $bluebell;
      }
      .comment-content {
        max-height: 100px;
        overflow-y: auto;
        overflow-wrap: break-word;
      }
    }
    .image-element {
      width: 24px;
      height: 24px;
      margin-right: 18px;
      align-self: flex-start;
    }
  }
}
</style>
